export const iconBoxData = [
	{
		iconClass: "icon-shipping",
		title: "Livrare la cel mai bun preț",
		description: "Asiguram cel mai bun preț de livrare pentru comenzile tale.",
          key1: "cards_info1", 
          key2: "cards_info1_text"
	},
	{
		iconClass: "icon-payment fs-22",
		title: "Diverse modalități de plată",
		description: "Plătește cu orice tip de card dorești. Multiple opțiuni disponibile.",
          key1: "cards_info2", 
          key2: "cards_info2_text"
	},
	{
		iconClass: "icon-return fs-20",
		title: "14 zile retur gratuit",
		description: "14 zile pentru a te convinge că produsul este ceea ce îți dorești.",
          key1: "cards_info3", 
          key2: "cards_info3_text"
	},
	{
		iconClass: "icon-suport",
		title: "Suport Premium",
		description: "Asistăm în permanență pentru a te ajuta în orice situație.",
          key1: "cards_info4", 
          key2: "cards_info4_text" 
	},
];
